// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropdownMenu_dropdown__GymYD","link":"DropdownMenu_link__pgZ4G","link__icon":"DropdownMenu_link__icon__3DwsB"};